import React, { useEffect } from "react";
import {
  Box,
  Button,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { AddCircle, RemoveCircle } from "@mui/icons-material";
import { useFormik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { getServiceById, updateService } from "../../redux/Slice/serviceslice";
import { setLoading } from "../../redux/Slice/loaderSlice";
import { toast } from "sonner";
import { clearMessage } from "../../redux/Slice/message";
import Grid from "@mui/material/Grid2"
import { QuoteTemplate } from "../Quote/quoteTemplate";
import { Temp } from "./Temp";

// Form validation schema using Yup
const validationSchema = yup.object().shape({
  name: yup
    .string()
    .required("Service type is required"),
});

const ViewService = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const message = useSelector((state) => state.message);
   const { serviceDetails, totalPages } = useSelector((state) => state.service);
  console.log("Services:",serviceDetails);
  
  const id = params?.id;

  useEffect(() => {
    dispatch(setLoading(true));
    dispatch(getServiceById(id))
      .unwrap()
      .then(() => {
        dispatch(setLoading(false));
      })
      .catch(() => {
        dispatch(setLoading(false));
        toast.error("Failed to fetch service details.");
      });
  }, [dispatch, id]);

  useEffect(() => {
    if (message?.message) {
      toast(message.message);
      dispatch(clearMessage());
    }
  }, [message, dispatch]);

  const formik = useFormik({
    initialValues: {
      name: serviceDetails?.name || "",
      features: serviceDetails?.features || [{ key: "", value: "" }],
      status: serviceDetails?.status || true,
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      const updatedFeatures = values.features.filter((feature) => feature.key.trim() !== "");
      const payload = {
        ...values,
        features: updatedFeatures,
        name: values.name
      };

      dispatch(setLoading(true));
      dispatch(updateService({ id, formData: payload })).unwrap()
        .then(() => {
          dispatch(setLoading(false));
          navigate('/services');
        })
        .catch(() => {
          dispatch(setLoading(false));
        });
    },
  });

  const handleAddFeature = () => {
    formik.setFieldValue("features", [...formik.values.features,{ key: "", value: "" }]);
  };

  const handleRemoveFeature = (index) => {
    const updatedFeatures = [...formik.values.features];
    updatedFeatures.splice(index, 1);
    formik.setFieldValue("features", updatedFeatures);
  };

  return (
    <Grid container spacing={5}>
          <Grid size={4}>
          <Typography variant="h5" sx={{my: 2}}>
      {serviceDetails?.name}
      </Typography>
          <Box
      sx={{
        padding: 4,
        border: "1px solid #ccc",
        borderRadius: 2,
        maxWidth: 600,
        margin: "auto",
      }}
    >
      <Typography variant="h6" sx={{fontStyle:'italic', fontWeight:'500'}} marginBottom={3}>
        Features
      </Typography>
      {serviceDetails?.features?.map((va, index)=>(
        <Typography variant="h6" sx={{fontSize: 16}} marginBottom={2}>
        {va?.key}
      </Typography>
      ))}
    </Box>
          </Grid>
          <Grid size={8}>
      <Temp service_id={id}/>
          </Grid>
    </Grid>
  );
};

export default ViewService;
